// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lecturer that can be author or corrector of a module
 */
export interface LecturerOutput {
  id?: unknown;
  name: unknown;
  title: unknown;
  firstname: unknown;
  lastname: unknown;
  avatar?: unknown;
}
